// extracted by mini-css-extract-plugin
export var actionText = "_mv-4";
export var container = "_mv-0";
export var leftSection = "_mv-1";
export var rightSection = "_mv-2";
export var settingsButton = "_mv-6";
export var settingsIcon = "_mv-7";
export var shortcut = "_mv-5";
export var shortcutGroup = "_mv-3";